import { render, staticRenderFns } from "./BulkMessageRecipients.vue?vue&type=template&id=52278088&scoped=true"
import script from "./BulkMessageRecipients.vue?vue&type=script&lang=js"
export * from "./BulkMessageRecipients.vue?vue&type=script&lang=js"
import style0 from "./BulkMessageRecipients.vue?vue&type=style&index=0&id=52278088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52278088",
  null
  
)

export default component.exports